module.exports = __webpack_public_path__ + "CGU.pdf";


/*****************
 ** WEBPACK FOOTER
 ** ./~/file-loader?name=[name].pdf!./client/resources/CGU.pdf
 ** module id = 950
 ** module chunks = 1
 **/